<template>
    <div>
        <!--/* Spinner */-->
        <page-loading-spinner :is-initial-loading="isInitialLoading" :is-refresh-loading="isRefreshLoading" />

        <div v-if="!isInitialLoading">
            <CartPageHeader v-once :title="cartPageDto.title" />

            <hr class="separator separator--gray4 w-100">

            <div style="--bs-bg-opacity: 1;background-color: rgba(var(--bs-gray2-rgb), var(--bs-bg-opacity)) !important;">
                <div id="cartContentContainer" ref="cartContentContainer" class="container-fluid">
                    <div class="row py-2 py-md-3">
                        <template v-if="cartItemsIsFilled">
                            <div class="col-12 col-md-8 px-1">
                                <CartPageInternetMobileDevicePackContent
                                    :internet-dto="cartData.filledInternetContent"
                                    :mobile-dto="cartData.filledMobileContent"
                                    :cross-sell-content="cartData.crossSellContent"
                                    :promotion-content="cartData.promotionContent"
                                    :total-discounts-label="cartData.totalDiscountsLabel"
                                    :device-dto="cartData.filledDeviceContent"
                                    @remove-item-from-cart-in-progress="cartModificationInProgress($event)"
                                    @remove-item-from-cart-success="displayMessageAndRefresh($event)"
                                    @remove-item-from-cart-error="displayMessageAndRefresh($event)"
                                    @sponsor-success="onSponsorSuccess($event)"
                                />
                                <CartPageDeviceContent
                                    v-if="cartData.filledDeviceContent && !shouldShowDeviceInPack"
                                    :device-dto="cartData.filledDeviceContent"
                                    @remove-item-from-cart-in-progress="cartModificationInProgress($event)"
                                    @remove-item-from-cart-success="displayMessageAndRefresh($event)"
                                    @remove-item-from-cart-error="displayMessageAndRefresh($event)"
                                />
                            </div>
                            <div class="col-12 col-md-4 mt-1 mt-md-0 px-1">
                                <CartPageRecap :dto="cartData.recap" />
                            </div>
                            <template v-if="cartData.crossSellContent">
                                <div v-if="cartData.crossSellContent.showNewDesign">
                                    <CartPageCrossSellContent
                                        :dto="cartData.crossSellContent"
                                        @add-mobile-offer-in-progress="cartModificationInProgress($event)"
                                        @add-mobile-offer-success="displayMessageAndRefresh($event)"
                                        @add-mobile-offer-error="displayMessageAndRefresh($event)"
                                    />
                                </div>
                                <div v-else>
                                    <div class="col-12 px-1 py-2">
                                        <hr class="separator separator--gray4">
                                    </div>
                                    <div id="cross-sell-content" class="col-12 px-1">
                                        <CartPageCrossSellContentNonModal
                                            :dto="cartData.crossSellContent"
                                            @add-mobile-offer-in-progress="cartModificationInProgress($event)"
                                            @add-mobile-offer-success="displayMessageAndRefresh($event)"
                                            @add-mobile-offer-error="displayMessageAndRefresh($event)"
                                        />
                                    </div>
                                </div>
                            </template>
                        </template>
                        <template v-else>
                            <div class="col-12 px-1 mb-2">
                                <CartPageEmptyContent
                                    :dto="cartPageDto.emptyContent"
                                    :shop-sosh="cartPageDto.shopSosh" />
                            </div>
                        </template>
                    </div>
                </div>
            </div>

            <hr class="separator separator--gray4 w-100">

            <div class="bg-gray2">
                <CartLegalMentions
                    v-if="cartLegalMentions"
                    :legal-mentions="cartLegalMentions"
                />
            </div>

            <EChatButton
                v-if="eChatButton && eChatButton.showEChatButton"
                :id="eChatButton.id"
                :is-bottom="eChatButton.isBottom"
                :section="eChatButton.section"
            />
        </div>

        <div v-if="cartPageDto.fiberStatusOverlay">
            <OverlayDialog
                :id="'fiber-status-overlay'"
                :modal-button-label="'Fermer'"
                :action-label="'Ouvrir'"
                :is-auto-opened="true"
                :tms-category="cartPageDto.fiberStatusOverlay.tms.category"
                :tms-label="cartPageDto.fiberStatusOverlay.tms.label"
                :modal-title="cartPageDto.fiberStatusOverlay.title"
                :modal-content="cartPageDto.fiberStatusOverlay.content"
            />
        </div>

        <div class="bg-dark">
            <div class="container-fluid">
                <OrangeCommitments v-once :commitments="cartPageDto.commitments" />
            </div>
        </div>

        <ob1-snack-bar
            id="cartPageSnackbar"
            ref="cartPageSnackbar"
            class="over-page-loading-spinner"
            :icon="snackbarIcon"
            :label="snackbarMessage"
        />

        <FeedbackModalDialog
            v-if="confirmationMessage"
            :id="'cartConfirmationDialog'"
            ref="feedbackConfirmationDialog"
            :modal-content="confirmationMessage.text"
            :modal-title="confirmationMessage.title"
        >
            <template #actionButton>
                <Bouton
                    :label="confirmationMessage.buttonLabel"
                    :is-primary="false"
                    @click="initConfirmationCart"
                />
            </template>
        </FeedbackModalDialog>
    </div>
</template>

<script>
import axiosConfig from "../../config/axiosConfig";
import {CartService} from "../../../showcase/services/CartService";
import {OfferUniverse} from "../../../showcase/models/CartApiResponse";
import CartPageHeader from "./CartPageHeader.vue";
import OrangeCommitments from "../../../fmfmo/common/components/OrangeCommitments.vue";
import CartLegalMentions from "./CartLegalMentions.vue";
import CartPageRecap from "./CartPageRecap.vue";
import CartPageEmptyContent from "./CartPageEmptyContent.vue";
import CartPageCrossSellContent from "./CartPageCrossSellContent.vue";
import CartPageCrossSellContentNonModal from "./CartPageCrossSellContentNonModal.vue";
import PageLoadingSpinner from "../../components/custom/PageLoadingSpinner.vue";
import OverlayDialog from "../../components/ob1/OverlayDialog.vue";
import CartPageInternetMobileDevicePackContent from "./CartPageInternetMobileDevicePackContent.vue";
import CartPageAdditionalAcquisition from "./CartPageAdditionalAcquisition.vue";
import EChatButton from "../../components/custom/EChatButton.vue";
import CartPageDeviceContent from "./CartPageDeviceContent.vue";
import Bouton from "../../components/ob1/Bouton.vue";
import FeedbackModalDialog from "../../components/vue/FeedbackModalDialog.vue";

export default {
    name: "CartPage",
    components: {
        CartPageDeviceContent,
        Bouton,
        FeedbackModalDialog,
        EChatButton,
        OverlayDialog,
        PageLoadingSpinner,
        CartPageCrossSellContent,
        CartPageCrossSellContentNonModal,
        CartPageEmptyContent,
        CartPageHeader,
        CartPageRecap,
        CartPageAdditionalAcquisition,
        CartLegalMentions,
        OrangeCommitments,
        CartPageInternetMobileDevicePackContent,
    },
    data() {
        return {
            cartPageDto: cartPageDto,
            cartData: null,
            legalMentions: null,
            cartSnackBarAlerts: null,
            isInitialLoading: true,
            isRefreshLoading: false,
            snackbarMessage: "",
            snackbarIcon: "icon-error-severe",
            confirmationParameters: null,
            confirmationMessage: null,
        };
    },
    computed: {
        eChatButton: function () {
            if (this.cartData?.echatButton) {
                return {
                    showEChatButton: this.cartData.echatButton.showEChatButton,
                    id: this.cartData.echatButton.id,
                    isBottom: this.cartData.echatButton.isBottom,
                    section: this.cartData.echatButton.section
                };
            }
            return undefined;
        },
        cartItemsIsFilled: function () {
            return this.cartData
        },
        cartLegalMentions: function () {
            return this.legalMentions
        },
        shouldShowDeviceInPack: function () {
            return !!(this.cartData?.filledInternetContent && this.cartData?.filledMobileContent && this.cartData?.filledDeviceContent);
        }
    },
    mounted() {
        this.createCartIfNeeded();
    },
    methods: {
        createCartIfNeeded: function () {
            const offerId = getParameterByName('offerId', window.location.href);
            if (!offerId) {
                this.fetchCartDetails();
                return;
            }

            this.submitCartCreation({
                id: offerId,
                device: null,
                mobileId: null,
                universe: OfferUniverse.MOBILE
            });
        },
        submitCartCreation: function (request) {
            this.isRefreshLoading = true;
            CartService.setCart(request).then((response) => {
                window.location.replace(response.redirectUrl);
            }).catch((error) => {
                if (error?.type === 'needConfirmation' && error.parameters && error.message) {
                    this.confirmationParameters = error.parameters;
                    this.confirmationMessage = error.message;
                    this.isInitialLoading = false;
                    this.isRefreshLoading = false;
                    this.$nextTick(() => {
                        this.$refs.feedbackConfirmationDialog?.open();
                    });
                    return;
                }
                this.isInitialLoading = false;
                this.isRefreshLoading = false;
            });
        },
        initConfirmationCart: function () {
            const parameters = this.confirmationParameters;
            if (!parameters || !parameters.id) {
                return;
            }

            this.$refs.feedbackConfirmationDialog?.close();
            this.submitCartCreation({
                id: parameters.id,
                universe: parameters.universe === OfferUniverse.INTERNET ? OfferUniverse.INTERNET : OfferUniverse.MOBILE,
                mobileId: parameters.mobileId || null,
                device: parameters.device || null,
            });
        },
        cartModificationInProgress: function () {
            this.isRefreshLoading = true;
            this.scrollToCartContentContainer();
        },
        scrollToCartContentContainer: function () {
            this.scrollToRef(this.$refs["cartContentContainer"]);
        },
        scrollToRef: function (ref) {
            if (ref) {
                ref.scrollIntoView({behavior: "smooth", block: "start"});
            }
        },
        displayMessageAndRefresh: function(event) {
            if ((event) && (event.snackBarAlert)) {
                this.displaySnackBarAlertMessage(event.snackBarAlert);
            }
            this.fetchCartDetails();
        },
        onSponsorSuccess: function(event) {
            if (event && event.snackBarAlert) {
                this.displaySnackBarAlertMessage(event.snackBarAlert);
            }
            this.isRefreshLoading = true;
            this.scrollToCartContentContainer();
            this.fetchCartDetails();
        },
        displaySnackBarAlertMessage: function(snackBarAlert) {
            if (snackBarAlert) {
                this.snackbarMessage = snackBarAlert.message;
                this.snackbarIcon = snackBarAlert.icon;
                const snackbar = this.$refs.cartPageSnackbar;
                if (snackbar) {
                    snackbar.show();
                }
            }
        },
        fetchCartDetails: function () {
            const url = this.cartPageDto.cartPageInfoApiBaseUrl;
            axiosConfig.get(url, { withCredentials: true })
                .then(response => {
                    const result = response.data;
                    if (result) {
                        this.cartData = result.cartData;
                        this.legalMentions = result.legalMentions;
                        const dataLayer = result.dataLayer;

                        if (dataLayer) {
                            Tms.view(dataLayer);
                        }

                        if (!this.isInitialLoading) {
                            this.scrollToCartContentContainer();
                        }
                        this.isInitialLoading = false;
                        this.isRefreshLoading = false;
                    }
                })
                .catch(error => {
                    const redirectUrl = error.response && error.response.data && error.response.data.redirectUrl;
                    if (redirectUrl) {
                        window.location.href = redirectUrl;
                    } else {
                        this.isInitialLoading = false;
                        this.isRefreshLoading = false;
                    }
                });
        }
    },
};
</script>

<style scoped lang="scss">

.over-page-loading-spinner {
    z-index: 1001;
}

</style>

